<template>
    <jin-dialog v-model="visible" custom-class="ushk-remark" size="large">
      <!-- <div slot="title" class="ushk-remark-title-inset"></div> -->
      <div v-if="data.type === 'image-text'" class="ushk-remark__ctn">
        <div class="ushk-remark__img">
          <img :src="data.pic" alt="">
        </div>
        <p>
          {{ data.content }}
        </p>
      </div>
      <template v-if="data.type === 'content'">
        <div class="ushk-remark-content">
          <i></i>
          <h3 class="ushk-remark__title">
            {{ data.title }}
          </h3>
          <div class="ushk-remark__text">
            {{ data.content }}
          </div>
          <i></i>
        </div>
        <div class="ushk-remark-content__info">美港电讯注</div>
      </template>
      <div v-if="data.type === 'video'" class="ushk-remark-video">
        <div class="ushk-remark-video__b">
          <video width="100%" height="100%" :poster="data.cover" :src="data.link" controls="controls" preload="none" playsinline></video>
        </div>
        <p>
          {{ data.content }}
        </p>
      </div>
    </jin-dialog>
  </template>
  
  <script>
  
  export default {
    name: '',
    props: {
      remarkData: Object,
      value: {
        type: Boolean,
        default: false
      }
    },
    data () {
      return {
        visible: this.value,
        data: {}
      }
    },
    watch: {
      value (v) {
        this.visible = v
        if (v) {
          this.data = this.remarkData
        } else {
          setTimeout(() => {
            this.data = {}
          }, 200)
        }
      },
      visible (v) {
        this.$emit('input', v)
      }
    }
  }
  </script>
  



// WEBPACK FOOTER //
// RemarkDialog.vue?c1ca23a6